<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="read"/>
      Información Académica
    </span>
  <a-card>
    <div v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_ACADEMIA', 'NO') === 'SI'">
      <a-alert
        :message="$getConfigValue('MENSAJE1_ALERTA_ACADEMIA')"
        :description="$getConfigValue('MENSAJE2_ALERTA_ACADEMIA')"
        type="info"
        show-icon
      />
      <br>
    </div>
    <g-master name="biodatainformacionacademica"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="bioParentData"
              @action="masterAction"
              :beforeSend="master.beforeSend"
              ref="masterComponent"
              modalWidth="60%"
    >
      <template slot="expandedRowRender" slot-scope="{text}">
        <template v-for="ve in master.valoresExpandidos">
          <div v-if="mostrarCartaProfesional">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </div>
          <div v-else>
            <div v-if="ve.label !== 'Carta profesional'">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </div>
          </div>
        </template>
      </template>

      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de estudio')"
                        :formItemConfig="fiOptions"
                        :selectedObj.sync="type_degree"
                        :decorator="['id_h_type_degree', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="id_h_type_degree">
            </g-dropdown>
          </a-col>
          <a-col v-if="mostrarCampoSemestresAprobados" v-bind="colOptions">
            <a-form-item :label="$t('Semestres Aprobados')">
              <a-input
                class="ant-uppercase"
                v-decorator="['semesters_approved', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-if="mostrarCampoFechaInicio" v-bind="colOptions">
            <a-form-item :label="$t('Fecha inicio')">
              <a-date-picker style="width: 100%"
                             v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha fin')">
              <a-date-picker style="width: 100%"
                             v-decorator="['end_date', { rules: [{ required: false }] }]"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Otra Institución:')" :has-feedback="false">
              <a-checkbox v-model="ischeck_other_institution">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <div v-show="ischeck_other_institution">
              <a-form-item :label="$t('Institución')">
                <a-input
                  class="ant-uppercase"
                  v-decorator="['other_institution', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </div>
            <div v-show="!ischeck_other_institution">
              <g-lookup endpoint="hierarchy_lookup"
                          :formItemConfig="fiOptions"
                          style="width: 100%"
                          :label="$t('Institución')"
                          :selectedObj.sync="dropdown.institution"
                          :decorator="['id_h_entity', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        ref="id_h_entity"
                          :params="id_h_entity">
              </g-lookup>
            </div>
          </a-col>
          <a-col v-if="mostrarCampoOtroTitulo" v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Otro Titulo')" :has-feedback="false">
              <a-checkbox v-model="ischeck_other_degree">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <div v-show="ischeck_other_degree">
              <a-form-item :label="$t('Titulo')">
                <a-input
                  class="ant-uppercase"
                  v-decorator="['other_degree', { rules: [{  required: false, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </div>
            <div v-show="!ischeck_other_degree">
              <g-lookup endpoint="hierarchy_lookup"
                          :formItemConfig="fiOptions"
                          :label="$t('Titulo')"
                          :selectedObj.sync="dropdown.degree"
                          :decorator="['id_h_program', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        ref="id_h_program"
                          :params="id_h_program">
              </g-lookup>
            </div>
          </a-col>
          <a-col v-if="mostrarTelefono" v-bind="colOptions">
            <a-form-item :label="$t('Teléfono')">
              <a-input
                class="ant-uppercase"
                v-decorator="['phone', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-if="mostrarCampoDescripcion" v-bind="colOptions">
            <a-form-item :label="$t('Descripción')">
              <a-textarea autoSize
                          v-decorator="['description', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-if="mostrarTemasPrincipales" v-bind="colOptions">
            <a-form-item :label="ltemasprincipales">
              <a-input
                class="ant-uppercase"
                v-decorator="['subjects', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item :label="lproyectogrado">
              <a-input
                class="ant-uppercase"
                v-decorator="['graduation_project', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>

          <a-col v-if="mostrarPractica" v-bind="colOptions">
            <a-form-item :label="$t('Practica')">
              <a-input
                class="ant-uppercase"
                v-decorator="['practice', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('País')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_country', { rules: [{ required: false }] }]"
                        :customSlots="['suffixIcon']"
                        :selectedObj.sync="dropdown.country"
                        :params="id_h_country"
                        ref="id_h_country">
              <template slot="suffixIcon">
                <img style="max-width: 20px"
                     :src="flags[dropdown.country.equivalency]"
                     alt=""
                     v-if="dropdown.country && dropdown.country.equivalency">
              </template>
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-lookup endpoint="hierarchy_lookup"
                      :formItemConfig="fiOptions"
                      :label="$t('Ciudad')"
                      :selectedObj.sync="dropdown.city"
                      :decorator="['id_h_city', { rules: [{ required: false}] }]"
                      ref="id_h_city"
                      :params="cityParams">
            </g-lookup>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Actualmente Estudia')"
                        :formItemConfig="fiOptions"
                        :decorator="['study_now', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :params="code_status_sn">
            </g-dropdown>
          </a-col>
          <a-col v-if="mostrarCartaProfesional" v-bind="colOptions">
            <a-form-item :label="$t('Carta profesional')">
              <a-input
                class="ant-uppercase"
                v-decorator="['professional_card', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </a-card>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['persona'],
    computed: {
      mostrarTelefono () {
        let existeParametro = this.$getConfigValue('MOSTRAR_TELEFONO_PRACTICA_TEMAS')
        if (this.$isEmpty(existeParametro) || existeParametro === 'SI') {
          return true
        } else {
          return false
        }
      },
      mostrarPractica () {
        let existeParametro = this.$getConfigValue('MOSTRAR_TELEFONO_PRACTICA_TEMAS')
        if (this.$isEmpty(existeParametro) || existeParametro === 'SI') {
          return true
        } else {
          return false
        }
      },
      mostrarTemasPrincipales () {
        let existeParametro = this.$getConfigValue('MOSTRAR_TELEFONO_PRACTICA_TEMAS')
        if (this.$isEmpty(existeParametro) || existeParametro === 'SI') {
          return true
        } else {
          return false
        }
      },
      cityParams () {
        return {h_lookup_type: 'CIUDADES_HV', id_h_lookup_father: this.dropdown.country.value}
      },
      bioParentData () {
        return {
          id_person: this.persona
        }
      }
    },
    data () {
      return {
        mostrarCampoSemestresAprobados: this.$getConfigValue('MOSTRAR_BIODATA_ACADEMIA_SEMESTRES_APROBADOS') !== 'NO',
        mostrarCampoFechaInicio: this.$getConfigValue('MOSTRAR_BIODATA_ACADEMIA_FECHA_INICIO') !== 'NO',
        mostrarCampoOtroTitulo: this.$getConfigValue('MOSTRAR_BIODATA_ACADEMIA_OTRO_TITULO') !== 'NO',
        mostrarCampoDescripcion: this.$getConfigValue('MOSTRAR_BIODATA_ACADEMIA_DESCRIPCION') !== 'NO',
        valuechangelabel: this.$getConfigValue('BIODATA_INFORMACION_ACADEMICA_LABEL_DINAMICA', 'NO') === 'SI',
        ischeck_other_institution: false,
        ischeck_other_degree: false,
        mostrarCartaProfesional: this.$getConfigValue('OCULTAR_ASPIRACION_RECLUTAMIENTO_BIODATA', 'SI') === 'NO',
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        ltemasprincipales: 'Temas principales',
        lproyectogrado: 'Proyecto de Grado',
        code_status_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        flags: FLAGS,
        dropdown: {
          country: {},
          city: {},
          degree: {},
          institution: {}
        },
        type_degree: {},
        id_h_type_degree: {
          h_lookup_type: 'NIVEL_ESTUDIO'
        },
        id_h_entity: {
          h_lookup_type: 'INSTITUCIONES'
        },
        id_h_program: {
          h_lookup_type: 'PROGRAMAS'
        },
        id_h_country: {
          h_lookup_type: 'PAISES_HV'
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          beforeSend: (data) => {
            if (this.ischeck_other_degree) {
              data.check_other_degree = 'ACT'
              data.id_h_program = ''
              data.degree = this.degree
            } else {
              data.check_other_degree = 'INA'
              data.other_degree = ''
              if (!JsUtils.isEmpty(this.dropdown.degree.text)) {
                data.degree = this.dropdown.degree.text
              } else {
                data.degree = ''
              }
              this.degree = ''
            }
            if (this.ischeck_other_institution) {
              data.check_other_institution = 'ACT'
              data.id_h_entity = ''
              data.institution = this.institution
            } else {
              data.check_other_institution = 'INA'
              data.other_institution = ''
              data.institution = this.dropdown.institution.text
              if (!JsUtils.isEmpty(this.dropdown.institution.text)) {
                data.institution = this.dropdown.institution.text
              } else {
                data.institution = ''
              }
            }
            return data
          },
          valoresExpandidos: [
            {label: 'Carta profesional', column: 'professional_card'},
            {label: 'Teléfono', column: 'phone'},
            {label: 'Descripción', column: 'description'},
            {label: 'Temas principales', column: 'subjects'},
            {label: 'País', column: 'h_country'},
            {label: 'Ciudad', column: 'h_city'}
          ],
          endpoint: 'person_academic',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id_academic'
            },
            columns: [
              {title: 'Título obtenido', dataIndex: 'degree', sorter: true},
              {title: 'Tipo de estudio', dataIndex: 'h_type_degree', sorter: true},
              {title: 'Fecha de inicio', dataIndex: 'init_date_desc', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end_date_desc', sorter: true},
              {title: 'Institución', dataIndex: 'institution', sorter: true},
              {title: 'Semestres aprobados', dataIndex: 'semesters_approved', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado el', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'degree'},
            {name: 'id_h_type_degree'},
            {name: 'id_h_entity'},
            {name: 'id_h_program'},
            {name: 'id_h_country'},
            {name: 'id_h_city'},
            {name: 'init_date'},
            {name: 'end_date'},
            {name: 'institution'},
            {name: 'other_institution'},
            {name: 'other_degree'},
            {name: 'semesters_approved'},
            {name: 'professional_card'},
            {name: 'phone'},
            {name: 'description'},
            {name: 'check_other_degree'},
            {name: 'check_other_institution'},
            {name: 'init_date', type: 'date'},
            {name: 'end_date', type: 'date'},
            {name: 'subjects'},
            {name: 'semesters_approved'},
            {name: 'graduation_project'},
            {name: 'graduation_project'},
            {name: 'practice'},
            {name: 'study_now'}

          ]
        }
      }
    },
    methods: {
      changeLabel (value) {
        this.ltemasprincipales = value === 'CURSO DE SEGURIDAD' ? 'Nit Escuela Vigilancia' : 'Temas principales'
        this.lproyectogrado = value === 'CURSO DE SEGURIDAD' ? 'Nro Curso(ECSP)' : 'Proyecto de Grado'
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.ischeck_other_degree = false
            this.ischeck_other_institution = false
            break
          case 'masterEdit':
            if (action.record.check_other_degree) {
              this.ischeck_other_degree = true
            } else {
              this.ischeck_other_degree = false
            }
            if (action.record.check_other_institution) {
              this.ischeck_other_institution = true
            } else {
              this.ischeck_other_institution = false
            }
            if (!JsUtils.isEmpty(action.record.id_h_program)) {
              this.$refs.id_h_program && this.$refs.id_h_program.handleSearch(action.record.id_h_program)
            } else {
              this.degree = action.record.other_degree
            }
            if (!JsUtils.isEmpty(action.record.id_h_entity)) {
              this.$refs.id_h_entity && this.$refs.id_h_entity.handleSearch(action.record.id_h_entity)
            } else {
              this.institution = action.record.other_institution
            }
            if (!JsUtils.isEmpty(action.record.id_h_city)) {
              this.$refs.id_h_city && this.$refs.id_h_city.handleSearch(action.record.id_h_city)
            }
            this.changeLabel(action.record.h_type_degree)
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.other_degree)) {
              if (!JsUtils.isEmpty(action.changedFields.other_degree.value)) {
                this.degree = action.changedFields.other_degree.value
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.other_institution)) {
              if (!JsUtils.isEmpty(action.changedFields.other_institution.value)) {
                this.institution = action.changedFields.other_institution.value
              }
            }
        }
      }
    },
    watch: {
      type_degree () {
        if (this.valuechangelabel) {
          this.changeLabel(this.type_degree.text)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataInformacionAcademica.vue